import { PortalAuthHttpError, WrongPasswordFormatError } from '../error';
import { PortalApiClient } from '../portalApiClient';

export async function changePassword(
  newPassword: string,
  userId: number,
  client: PortalApiClient
) {
  try {
    const { data, error, response } = await client.untyped.POST(
      `/api/v1/users/${userId}/password`,
      {
        body: { newPassword },
      }
    );
    if (!response.ok) {
      const errorData = error as { message?: string } | undefined;
      const message = errorData?.message;
      if (response.status === 400 && message) {
        throw new WrongPasswordFormatError(message);
      }
      throw new PortalAuthHttpError(
        message ?? 'Password change failed',
        response.status
      );
    }
    return data;
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
}
